import styled from 'styled-components'
import theme from 'theme_'

export const StyledCheckoutAmounts = styled.div`
  margin: ${theme.spacing.s} 0;

  @media ${theme.devices.tablet} {
    padding: 0 ${theme.spacing.xlarge};
  }
`
export const StyledCheckoutRow = styled.div<{ sumRow?: boolean }>`
  display: flex;
  justify-content: space-between;
  margin: ${theme.spacing.md} 0;
  color: ${theme.colors.otterWarmBlack};
  line-height: 22px;
  ${(p) =>
    p.sumRow &&
    `
    font-weight: bold;
  `};
`

export const StyledCheckoutRowSecondary = styled(StyledCheckoutRow)`
  color: ${theme.colors.disabledGrey};
`

export const StyledCheckoutRowLeft = styled.div`
  flex-basis: 75%;
`

export const StyledCheckoutRowRight = styled.div`
  text-align: right;
`

export const CheckoutRowSeparator = styled.div`
  width: 100%;
  height: 1px;
  background-color: ${theme.colors.separatorColor};
`
